interface EventPage {
  id: string;
  path: string;
}
export const getEventPages = (): EventPage[] => {
  const env = process.env.REACT_APP_CLIENT_ENVIRONMENT;

  if (env === 'local') {
    return [
      { id: 'db217960-a6d7-4dbe-b45a-5ca354ff8bcd', path: '/event-2024-02' },
      { id: '77218f92-5c6b-49b9-8b1f-b9b8c8660066', path: '/event-2024-05' },
    ];
  }

  if (env === 'development') {
    return [
      { id: '77218f92-5c6b-49b9-8b1f-b9b8c8660066', path: '/event-2024-02' },
      { id: 'e3c82276-3b67-43b2-813e-812d565ca70a', path: '/event-2024-05' },
    ];
  }

  return [
    { id: '7cca28cc-00cb-4f9b-850e-edfe76277484', path: '/event-2024-02' },
    { id: 'e562ebcd-044a-4dfc-89eb-880fd4f8b39a', path: '/event-2024-05' },
  ];
};
